import MarketBase from './market-base';
import MarketRule from './market-rule';
import MarketTariffService from './market-tariff-service';

export default class MarketCompany extends MarketBase  {
    Name: Array<string> = [];
    Rule: Array<MarketRule> = [];
    Service: Array<MarketTariffService> = [];
}